import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

// The panel preferences are listed on the PCB settings page, so a URL trimmed back to the collection lands there.
export const Route = createFileRoute('/_authenticated/next/settings/organization/pcb/panel-preferences/')({
    // Only redirects: `/settings/organization/pcb` checks its own access.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    beforeLoad: () => {
        throw redirect({ to: '/settings/organization/pcb', replace: true });
    },
});
